<template>
	<div class="row">
		<div class="col-xs-12">
			<p class="business-owner-question">Are you a business owner?</p>
			<div class="switch">
				<label>
					No
					<input type="checkbox" v-model="vm.mainModel.isBusinessOwner" @change="onIsBusinessOwnerChange">
					<span class="lever"></span>
					Yes
				</label>
			</div>
		</div>
		<div class="col-xs-12 business-owner-q2" v-if="vm.mainModel.isBusinessOwner === true">
			<p class="business-owner-question">Would you like to learn more about our services for your employees?</p>
			<div class="switch">
				<label>
					No
					<input type="checkbox" v-model="vm.mainModel.wantsEmployeeServicesInfo">
					<span class="lever"></span>
					Yes
				</label>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "BusinessOwnerSurvey",
		props: {
			value: { type: Object, required: true },
		},
		data() {
			return {
				vm: { ...this.value },
			};
		},
		mounted() {
			this.initializeDefaults();
		},
		methods: {
			initializeDefaults() {
				if (this.vm.mainModel.isBusinessOwner == null) {
					this.vm.mainModel.isBusinessOwner = false;
				}
				this.initializeWantsEmployeeServicesInfo();
			},
			initializeWantsEmployeeServicesInfo() {
				if (this.vm.mainModel.isBusinessOwner !== true || this.vm.mainModel.wantsEmployeeServicesInfo == null) {
					this.vm.mainModel.wantsEmployeeServicesInfo = false;
				}
			},
			onIsBusinessOwnerChange() {
				this.initializeWantsEmployeeServicesInfo();
			}
		}
	}
</script>

<style scoped>
	.business-owner-question {
		margin: 0 0 6px 0;
		font-weight: 600;
	}
	.business-owner-q2 {
		margin-top: 14px;
	}
</style>
